import { Injectable } from '@angular/core';
import { AccuserAppealDetailModel } from '../../view-models/appeal-judgement';
import { AccuseritemModel, AccuserModel } from '../../view-models/conferencing';
import { Mapper } from '../mapper';

@Injectable({
    providedIn: 'root'
})
export class AppealJudgementAccuserDetailMapper implements Mapper<AccuseritemModel, AccuserAppealDetailModel>  {
    constructor(

    ) { }
    mapForm(param: AccuseritemModel): AccuserAppealDetailModel {
        const data = new AccuserAppealDetailModel
        data.groupId = param.grouP_ID
        data.id = param.acC_ID
        data.seq = param.seq
        return data!
    }

    mapTo(param: AccuserAppealDetailModel): AccuseritemModel {
        const data = new AccuseritemModel
        data.acC_ID = param.id
        data.grouP_ID = param.groupId
        data.seq = param.seq
        if(param.groupId == 1){
            data.grouP_NAME = 'ผู้ฟ้องคดี'
        }else if(param.groupId == 2){
            data.grouP_NAME = 'ผู้ถูกฟ้องคดี'
        }
        data.checked = param.checked
        return data!
    }

} 